var TinyDatePicker = require('tiny-date-picker');
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var NEXT_CLASS = 'dp-next',
	PREV_CLASS = 'dp-prev',
	DAY_CLASS = 'dp-day',
	DAY_SELECTOR = '.' + DAY_CLASS,
	TIMESTAMP_DATA = 'data-date';

function formatDate(date) {
	return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
}

function DatePicker(el, settings) {
	this.el = el;
	this.isOpen = false;
	this.init(settings);
	this.isEventsBound = false;
}

DatePicker.prototype.init = function(settings) {
	var t = this,
		defaultSettings = {
			format: function (date) {
				return date.toLocaleDateString();
			},
			mode: 'dp-below',
			min: formatDate(new Date()),
      lang: {
        days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        today: '',
        clear: '',
        close: ''
      },
			onOpen: t.onOpen.bind(t),
			onSelectYear: t.filter.bind(t),
			onSelectMonth: t.filter.bind(t),
			disabled: [],
			parse: function(str) {
				if (! str) {
					return new Date();
				}
				var date = new Date(str.replace('-', '/'));
				return isNaN(date) ? new Date() : date;
			}
		};

	if (! settings) {
		settings = {};
	}

	if (settings.onOpen) {
		settings.onOpenCallback = settings.onOpen;
		settings.onOpen = defaultSettings.onOpen;
	}

	t.settings = $.extend({}, defaultSettings, settings);

	t.datepicker = new TinyDatePicker(t.el, t.settings);

	t.datepicker.on('close', function() {
    t.isOpen = false;
    t.el.focus();
  });

	t.datepicker.on('open', function(context) {
    document.querySelector('.dp-current').focus();
    document.querySelector('.dp').addEventListener('keydown', function(e) {
      var key = e.which || e.keyCode;

      if (key === 13) {
        e.stopPropagation();
        e.preventDefault();
      } else if (key === 9) {
        e.stopPropagation();
        t.el.focus();
      }
    });

    t.isOpen = true;
  });

	t.el.addEventListener('keydown', function(e) {
	  if (!t.isOpen) {
      var key = e.which || e.keyCode;

      if (key === 32) {
        t.datepicker.open();
      }
    }
  });

	t.el.addEventListener('change', function() {
		var
			current, selected,
			date = new Date(t.el.value);

		if (isDayOfWeek(date, t.settings.disabled)) {
			current = t.datepicker.el.querySelector('.dp-current');
			selected = t.datepicker.el.querySelector('.dp-selected');
			if (current) {
				current.classList.remove('dp-current');
			}
			if (selected) {
				selected.classList.remove('dp-selected');
			}
			t.el.value = '';
			t.filter(t.datepicker);
		} else {
			t.close();
		}

	});
};

DatePicker.prototype.filter = function(context) {
	filterDates(context, this.settings.disabled);
};

DatePicker.prototype.toggle = function () {
	if (this.datepicker.el) {
		this.close();
	} else {
		this.datepicker.open();
	}
	var iconCalendar = document.querySelector('.js-calendar-toggle');
	iconCalendar.classList.toggle('card-tabs__calendar--active');
};

DatePicker.prototype.close = function () {
	var el = this.datepicker.el;
	el && el.parentElement.removeChild(el);
	this.datepicker.el = undefined;
	if (this.settings.onClose) {
		this.settings.onClose();
	}
};

DatePicker.prototype.onOpen = function(context) {
	var t = this;
	filterDates(context, t.settings.disabled);

	if (t.isEventsBound) {
		return;
	}

	context.el.addEventListener('click', function(e) {
		if (e.target.classList.contains(NEXT_CLASS) ||
			e.target.classList.contains(PREV_CLASS)) {
			filterDates(context, t.settings.disabled);
		}
	});

	context.el.addEventListener('keydown', function(e) {
		this.filter(context);
	}.bind(t));

	t.alreadyInit = true;
};

DatePicker.prototype.getSelectedDate = function () {
	return this.datepicker.selectedDate;
};

function getDate(dayEl) {
	return new Date(parseInt(dayEl.getAttribute(TIMESTAMP_DATA)));
}

function isDayOfWeek(dateObject, arrayOfWeekdays) {
	return arrayOfWeekdays.indexOf(dateObject.getDay()) !== -1;
}

function filterDates(context, dateClose) {
	var days = Array.prototype.slice.call(context.el.querySelectorAll(DAY_SELECTOR));
	if( dateClose.length && days ) {
		var closeDays = days.filter(function(dayEl) {
			return isDayOfWeek(getDate(dayEl), dateClose);
		});
		closeDays.forEach(function(dayEl) {
			dayEl.classList.add(DAY_CLASS + '-disabled');
		});
	}
}


module.exports = DatePicker;
